/**
 * Cache key constants for neighborhood search queries
 */

// Base namespace for all neighborhood search queries
export const NS_CACHE_NAMESPACE = "NeighborhoodSearch";

// Saved search related cache keys
export const NS_SAVED_SEARCH_CACHE_KEY = `${NS_CACHE_NAMESPACE}:SavedSearch`;
export const NS_SAVED_SEARCH_DETAILS_CACHE_KEY = `${NS_CACHE_NAMESPACE}:SavedSearchDetails`;
export const NS_SAVED_SEARCH_STATUS_CACHE_KEY = `${NS_CACHE_NAMESPACE}:SavedSearchStatus`;
export const NS_LIST_SAVED_SEARCHES_CACHE_KEY = `${NS_CACHE_NAMESPACE}:ListSavedSearches`;
export const NS_INFINITE_LIST_SAVED_SEARCHES_CACHE_KEY = `${NS_CACHE_NAMESPACE}:InfiniteListSavedSearches`;

// Property search related cache keys
export const NS_SEARCH_PROPERTIES_CACHE_KEY = `${NS_CACHE_NAMESPACE}:SearchProperties`;
export const NS_PROPERTY_DETAILS_CACHE_KEY = `${NS_CACHE_NAMESPACE}:PropertyDetails`;

// Other cache keys
export const NS_LOOKUP_QUOTA_CACHE_KEY = `${NS_CACHE_NAMESPACE}:LookupQuota`;

// Mutation keys
export const NS_CREATE_SAVED_SEARCH_MUTATION_KEY = `${NS_CACHE_NAMESPACE}:CreateSavedSearch`;
export const NS_UPDATE_SAVED_SEARCH_MUTATION_KEY = `${NS_CACHE_NAMESPACE}:UpdateSavedSearch`;
export const NS_UPDATE_CONTACTS_MUTATION_KEY = `${NS_CACHE_NAMESPACE}:UpdateContacts`;
export const NS_COMBINE_LIST_OF_LEADS_MUTATION_KEY = `${NS_CACHE_NAMESPACE}:CombineListOfLeads`;

// Helper functions for generating parameterized cache keys
export const getNsSavedSearchCacheKey = (savedSearchId: string) => [NS_SAVED_SEARCH_CACHE_KEY, savedSearchId];
export const getNsSavedSearchDetailsCacheKey = (savedSearchId: string) => [NS_SAVED_SEARCH_DETAILS_CACHE_KEY, savedSearchId];
export const getNsSavedSearchStatusCacheKey = (savedSearchId: string) => [NS_SAVED_SEARCH_STATUS_CACHE_KEY, savedSearchId];
export const getNsPropertyDetailsCacheKey = (propertyId: string) => [NS_PROPERTY_DETAILS_CACHE_KEY, propertyId];
// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const getNsSearchPropertiesCacheKey = (listOptions: any) => [NS_SEARCH_PROPERTIES_CACHE_KEY, listOptions];